import { Property } from './property';

export class ComparableProperties {
    constructor(doc) {
        this.comparablePropertyList = [];
        for (const property of doc) {
            this.comparablePropertyList.push(new ComparableProperty(property));
        }
    }

    GetPropertyImages() {
        const images = [];
        let title = "Comparable #";
        let index = 0;
        for (const property of this.comparablePropertyList) {
            const img = property.GetPropertyImage();
            if (img !== null) {
                img.imageSourceCaption = title + (++index).toString();
                images.push(property.GetPropertyImage());
            }
        }
        return images;
    }

}

export class ComparableProperty extends Property {
    // constructor(doc) {
    //     super(doc);
    // }

    GetComparableAdjustment(type, identifier) {
        if (this.comparable === null) return null;
        if (this.comparable.comparableAdjustments === null) return null;
        for (const ca of this.comparable.comparableAdjustments) {
            if (ca.comparableAdjustmentType === type && ca.additionalComparisonLineItemIdentifier === identifier) {
                return ca;
            }
        }
        return null;
    }

    GetFinancingType() {
        if (this.comparable.comparableDetail.noFinancingTransactionIndicator ?? false) {
            return "Cash";
        }
        const mtg = this.comparable.GetMortgageType();
        if (mtg === null || mtg === "") return "--";
        return mtg;
    }
}
